// Country options for the "My region" picker. Codes are ISO 3166-1 alpha-2.
export const COUNTRIES = [
  { code: "US", label: "United States" },
  { code: "GB", label: "United Kingdom" },
  { code: "CA", label: "Canada" },
  { code: "AU", label: "Australia" },
  { code: "IE", label: "Ireland" },
  { code: "NZ", label: "New Zealand" },
  { code: "IN", label: "India" },
  { code: "DE", label: "Germany" },
  { code: "FR", label: "France" },
  { code: "ES", label: "Spain" },
  { code: "IT", label: "Italy" },
  { code: "NL", label: "Netherlands" },
  { code: "SE", label: "Sweden" },
  { code: "NO", label: "Norway" },
  { code: "DK", label: "Denmark" },
  { code: "FI", label: "Finland" },
  { code: "BE", label: "Belgium" },
  { code: "PT", label: "Portugal" },
  { code: "AT", label: "Austria" },
  { code: "CH", label: "Switzerland" },
  { code: "PL", label: "Poland" },
  { code: "BR", label: "Brazil" },
  { code: "MX", label: "Mexico" },
  { code: "AR", label: "Argentina" },
  { code: "JP", label: "Japan" },
  { code: "KR", label: "South Korea" },
  { code: "SG", label: "Singapore" },
  { code: "ZA", label: "South Africa" },
  { code: "AE", label: "United Arab Emirates" },
];

const CODE_SET = new Set(COUNTRIES.map((c) => c.code));

export function regionLabel(code) {
  const hit = COUNTRIES.find((c) => c.code === code);
  return hit ? hit.label : code;
}

// Best-effort country guess from the browser locale (navigator.language).
// e.g. "en-GB" -> "GB". Never uses IP. Returns null when there's no usable region.
export function localeCountry() {
  try {
    const langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (const l of langs) {
      const parts = (l || "").split("-");
      const region = parts[1] ? parts[1].toUpperCase() : null;
      if (region && CODE_SET.has(region)) return region;
    }
  } catch {
    /* no-op */
  }
  return null;
}
